import React from 'react'
import './v3-plan-routes.css'

interface V3PlanRouteShellProps {
  children: React.ReactNode
}

export default function V3PlanRouteShell({ children }: V3PlanRouteShellProps) {
  return (
    <div className="v3-plan-route w-full min-h-screen">
      <div className="w-full min-w-0">
        <div className="v3-plan-route__content min-w-0 border-0 rounded-none shadow-none background-transparent">
          {children}
        </div>
      </div>
    </div>
  )
}